import React, { Component } from "react";
import { Clock, Users, Calendar } from "lucide-react";
import Countdown from "react-countdown";
import i18n from "../../i18n";
import '../../styles/components/bidding-comp.scss';

class HeaderRowGrp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date().toLocaleString("en-US", { timeZone: "Asia/Riyadh" })
    };
  }

  render() {

    const FinishBid = () => (
      <span className="text-danger">{i18n.t("time_ends")}</span>
    );
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      if (completed) {
        return <FinishBid />;
      } else {
        let warning =
          days === 0 && hours === 0 && minutes === 0 && seconds < 10 ? true : false;
        console.log(warning);
        return (
          <span
            className={
              warning
                ? "text-danger countdown-listing-pg countdwn-warning"
                : "countdown-listing-pg"
            }
          >
            {days}
            {i18n.t("D")} : {hours}
            {i18n.t("H")} : {minutes}
            {i18n.t("M")} : {seconds}
            {i18n.t("S")}
          </span>
        );
      }
    };

    return (
      <div className="modern-reg-tabs">
        <div className="reg-tab-item">
          <div className="reg-tab-inner-item">
            <Calendar size={24} className="icon text-black" />
          </div>
          <div className="sa-details">
            <div className="label-text">{i18n.t("reg_start")}</div>
            <div className="value-text">
              {new Date(this.props.reg_start_date) < new Date()
                ? i18n.t('registration_started')
                : this.props.reg_start_date}
            </div>
          </div>
        </div>

        <div className="reg-tab-item">
          <div className="reg-tab-inner-item">
            <Clock size={24} className="icon text-black" />
          </div>
          <div className="sa-details">
            <div className="label-text">{i18n.t("reg_end")}</div>
            <div className="value-text">
              {/* <MockCountdown /> */}
              {(
                <Countdown
                  date={new Date(this.props.endTime)}
                  renderer={renderer}
                  now={() => new Date()}
                />)}
            </div>
          </div>
        </div>

        <div className="reg-tab-item">
          <div className="reg-tab-inner-item">
            <Users size={24} className="icon text-black" />
          </div>
          <div className="sa-details">
            <div className="label-text">{i18n.t("enrolled_users")}</div>
            <div className="value-text count-animation">
              {this.props.enrolledUsers}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderRowGrp;